import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';

export function newLeadAddedEvent({ customerId }: { customerId?: string }) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.NEW_LEAD_ADDED,
  };

  pushToDataLayer({
    ...eventAttributes,
    customer_id: customerId,
  });
}
